const FILTER_PARAM_PREFIX = "filter";

class RelativeLink extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  connectedCallback() {
    const anchor = this.querySelector("a");
    if (!anchor) return;

    try {
      const url = new URL(anchor.href);
      anchor.href = url.pathname + url.search + url.hash;
    } catch (e) {
      // href is already relative or invalid — leave it as-is
    }
  }

  /**
   * Offers the `filter*` params of links pointing at the current page to the
   * page itself, so filters can be applied without a page load. How they merge
   * with the filters already applied is up to the listener (see facets.js).
   *
   * The click is only swallowed if a listener cancels the dispatched event to
   * claim it, so links still navigate normally on pages without filtering.
   */
  onClick(event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const anchor = event.target.closest("a");
    if (!anchor || !this.contains(anchor)) return;
    if (anchor.target && anchor.target !== "_self") return;

    let url;

    try {
      url = new URL(anchor.href, window.location.href);
    } catch (e) {
      return;
    }

    if (url.pathname !== window.location.pathname) return;

    const filterParams = [];

    url.searchParams.forEach((value, key) => {
      if (key.startsWith(FILTER_PARAM_PREFIX)) filterParams.push([key, value]);
    });

    if (!filterParams.length) return;

    const addFiltersEvent = new CustomEvent("relative-link:add-filters", {
      cancelable: true,
      detail: { filterParams, url },
    });

    document.dispatchEvent(addFiltersEvent);

    if (addFiltersEvent.defaultPrevented) event.preventDefault();
  }
}

if (!customElements.get("relative-link")) {
  customElements.define("relative-link", RelativeLink);
}
